import { makeStyles } from 'tss-react/mui';

const name = 'GroupSelect';

export const useGroupSelectStyles = makeStyles({ name })(theme => ({
  root: {
    '&&': {
      width: 'unset',

      div: {
        borderRadius: theme.shape.borderRadiusMd,
      },

      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        width: '100%',
      },
    },
  },
  select: {
    paddingLeft: 0,
    paddingRight: theme.spacing(3),

    '&&': {
      width: 'fit-content',
      height: 32,

      backgroundColor: theme.palette.background.default,

      boxShadow: 'none',

      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },

    '& div': {
      color: theme.palette.text.primary,
    },

    '&.Mui-focused': {
      '& svg': {
        color: `${theme.palette.grey[600]}`,
      },
    },
  },
  input: {
    '&&': {
      display: 'flex',
      alignItems: 'center',

      width: 'unset',
      color: theme.palette.text.secondary,

      fontSize: 14,
      fontWeight: 500,
      lineHeight: '143%',

      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },

    padding: theme.spacing(2, 3, 2, 4),

    letterSpacing: '0.01em',

    '&:hover': {
      color: theme.palette.text.primary,
    },

    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  selectIcon: {
    top: theme.spacing(3.5),
    right: theme.spacing(3),
  },
  menuPaper: {
    '& li': {
      color: theme.palette.text.primary,

      fontWeight: 400,
      fontSize: theme.spacing(4),
      lineHeight: theme.spacing(6),

      '&.Mui-selected': {
        color: theme.palette.primary.main,
      },
    },
  },
}));
